import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import NewContentList from './NewContentList'
// import moment from "moment";

import ContentItem3 from "../../components/event/ContentItem3";

import "../../css/event210621.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Event202201_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
    list: [],
  };
  componentDidMount = () => {
    const eventCode = this.props.childProps.eventCode;
    this._getContentList(eventCode);
  };

  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202201_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  /*
    _expectApi = (keycode, contentSerial, grade) => {
        const { apiUrl, loginId } = this.props;
        
        return axios.post(apiUrl + '/event_202201_expect', {
            params: {
                keycode: keycode,
                contentSerial: contentSerial,
                grade: grade
            }
        })
    }
    */
  _renderItem = () => {
    const { contentList, keyCode } = this.state;
    const { _expect, reset } = this.props.childProps;
    const list = contentList.map((item, index) => {
      return (
        <ContentItem3
          key={index}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alram}
          keyCode={keyCode}
          _expect={_expect}
          grade={item.rank}
          reset={reset}
        />
      );
    });
    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    let test = [];

    if (eventCode === 1) {
      test = [];
    } else if (eventCode === 2) {
      test = [];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [];
    } else if (eventCode === 5) {
      test = [];
    }

    const list = test.map((item, index) => {
      return (
        <li key={index} style={{ width: 224, height: 502 }}>
          <div className="thumb"></div>
        </li>
      );
    });
    return list;
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    const { intReturn, contentList } = this.state;
    const { eventCode } = this.props.childProps;

    // let title = "";

    // if (eventCode === 1) {
    //   title = "3/26";
    // } else if (eventCode === 2) {
    //   title = "3/27";
    // } else if (eventCode === 3) {
    //   title = "3/28";
    // } else if (eventCode === 4) {
    //   title = "3/29";
    // } else if (eventCode === 5) {
    //   title = "3/30";
    // }
    return (
      <Fragment>
        <div className={"listWrap list0" + eventCode}>
          {eventCode === 1 ? (
            <h2>
              <img
                src="/img/event/event211217/list_top.png"
                alt="애니플러스 1분기 신작 주문표"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_top.png"
                alt="애니플러스 1분기 신작 주문표"
                className="img_m"
              />
              <img
                src="/img/event/event211217/list_01_tit.png"
                alt="#COFFE"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_01_tit.png"
                alt="#COFFE"
                className="img_m"
              />
            </h2>
          ) : eventCode === 2 ? (
            <h2>
              <img
                src="/img/event/event211217/list_02_tit.png"
                alt="#smoothie"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_02_tit.png"
                alt="#smoothie"
                className="img_m"
              />
            </h2>
          ) : eventCode === 3 ? (
            <h2>
              <img
                src="/img/event/event211217/list_03_tit.png"
                alt="#sparkling ade"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_03_tit.png"
                alt="#sparkling ade"
                className="img_m"
              />
            </h2>
          ) : eventCode === 4 ? (
            <h2>
              <img
                src="/img/event/event211217/list_04_tit.png"
                alt="#original tea"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_04_tit.png"
                alt="#original tea"
                className="img_m"
              />
            </h2>
          ) : eventCode === 5 ? (
            <h2>
              <img
                src="/img/event/event211217/list_05_tit.png"
                alt="#energy drink"
                className="img_web"
              />
              <img
                src="/img/event/event211217/m_list_05_tit.png"
                alt="#energy drink"
                className="img_m"
              />
            </h2>
          ) : null}

          {intReturn === 0 ? (
            <ul className="list">
              {contentList ? this._renderItem() : null}
              {contentList ? this._renderNull() : null}
            </ul>
          ) : (
            <Fragment></Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202201_contentList));
